import { ChangeEvent, FC } from 'react'

import { CircleCloseIcon } from '@icons/CircleCloseIcon'
import { SearchIcon } from '@icons/SearchIcon'

import styles from './DropdownSearchInput.module.scss'

export interface DropdownSearchInputProps {
  value?: string
  placeholder?: string
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  onSearch?: () => void
  onClear?: () => void
}

export const DropdownSearchInput: FC<DropdownSearchInputProps> = (props) => {
  const { value, placeholder, onChange, onSearch, onClear } = props

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange?.(event)
  }

  const handleButtonClick = () => {
    if (value?.length) {
      onClear?.()
    } else {
      onSearch?.()
    }
  }

  return (
    <div className={styles.dropdownSearchInput}>
      <input
        type='text'
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        autoFocus
      />
      <button onClick={handleButtonClick}>
        {value?.length ? <CircleCloseIcon /> : <SearchIcon />}
      </button>
    </div>
  )
}
